function isEmail(string) {
  const re =
    /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
  return re.test(string);
}

export function email(value) {
  return value && !isEmail(value.trim()) ? 'Invalid email' : null;
}

function isPhone(string) {
  return !!/^\+?\d[\d\s-]+$/.exec(string);
}

export function phone(value) {
  return value && !isPhone(value.trim()) ? 'Invalid phone' : null;
}

export function isVerification(value) {
  return value.length === 6 && /^\d+$/.test(value);
}

export function verification(value) {
  return value && !isVerification(value.trim()) ? 'Must be 6 digits' : null;
}

function hasCorrectLength(value) {
  return value.length >= 8 && value.length <= 99;
}

function hasNumber(value) {
  const re = /\d/;
  return re.test(value);
}

function hasLowerCase(value) {
  return value.toUpperCase() !== value;
}

function hasUpperCase(value) {
  return value.toLowerCase() !== value;
}

function hasSpecialCharacter(value) {
  const re = /[\s~`!@#$%^&*+=\-[\]\\';,/{}|\\":<>?()._]/g;
  return re.test(value);
}

export function password(value) {
  const e = 'Invalid password: ';

  if (!value) return undefined;
  if (!hasCorrectLength(value)) return e.concat('Must be of length 8 to 99');
  if (!hasNumber(value)) return e.concat('Must contain a number');
  if (!hasLowerCase(value)) return e.concat('Must contain a lower case character');
  if (!hasUpperCase(value)) return e.concat('Must contain an upper case character');
  if (!hasSpecialCharacter(value)) return e.concat('Must contain a special character');
  return undefined;
}

function isDirty(value) {
  return value || value === 0;
}

export function required(requiredFields, values) {
  return requiredFields.reduce(
    (fields, field) => ({
      ...fields,
      ...(isDirty(values[field]?.trim()) ? undefined : { [field]: 'Required' }),
    }),
    {},
  );
}